// 全局指令
export const global = {
};

// 局部指令
export const local = {
};
